import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('my-modal', {
    attrs: {
      "title": _vm.t('日志'),
      "data-sign": "product_batch_log_modal",
      "width": 900,
      "wrap-class-name": "modal-body"
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('my-table', {
    attrs: {
      "columns": _vm.columns,
      "bordered": "",
      "data-sign": "product_batch_log_table",
      "data-source": _vm.tableData,
      "row-key": "id"
    }
  }), _c('my-pagination', {
    attrs: {
      "value": _vm.searchData.page_index,
      "total": _vm.total,
      "page-size": _vm.searchData.page_size
    },
    on: {
      "update:pageSize": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "update:page-size": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "onChange": _vm.handlePageChange
    }
  }), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('a-button', {
    attrs: {
      "data-sign": "product_batch_log_close_btn",
      "fbu-analyse-name": $t("\u5173\u95ED")
    },
    on: {
      "click": function ($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.t('关闭')))])], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };